export class ServerLookup {
  constructor () {
    this._form = document.getElementById('server-lookup-form')
    this._addressInput = document.getElementById('lookup-address')
    this._typeSelect = document.getElementById('lookup-type')
    this._submitBtn = document.getElementById('lookup-btn')
    this._errorEl = document.getElementById('lookup-error')
    this._errorMsg = document.getElementById('lookup-error-msg')
    this._resultsEl = document.getElementById('lookup-results')

    this._form.addEventListener('submit', (e) => {
      e.preventDefault()
      this.checkServer()
    })
  }

  async checkServer () {
    const address = this._addressInput.value.trim()

    if (!address) {
      this.showError('Please enter a server address')
      return
    }

    this.setLoading(true)
    this.hideError()
    this.hideResults()

    try {
      const type = this._typeSelect.value
      const endpoint = type === 'java'
        ? `https://api.mcsrvstat.us/3/${address}`
        : `https://api.mcsrvstat.us/bedrock/3/${address}`

      const response = await fetch(endpoint)
      const data = await response.json()

      if (!response.ok || !data.online) {
        throw new Error(data.error || 'Server is offline or could not be reached.')
      }

      this.renderResults(data, address, type)
    } catch (err) {
      this.showError(err.message || 'Failed to check server status. Please verify the address and try again.')
    } finally {
      this.setLoading(false)
    }
  }

  setLoading (isLoading) {
    this._submitBtn.disabled = isLoading
    if (isLoading) {
      this._submitBtn.innerHTML = '<svg class="spinner" viewBox="0 0 24 24"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg> Checking...'
    } else {
      this._submitBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg> Check Status'
    }
  }

  showError (message) {
    this._errorMsg.textContent = message
    this._errorEl.style.display = 'flex'
  }

  hideError () {
    this._errorEl.style.display = 'none'
  }

  hideResults () {
    this._resultsEl.style.display = 'none'
  }

  renderResults (data, address, type) {
    // Header
    document.getElementById('lookup-result-address').textContent = address
    document.getElementById('lookup-result-type').textContent =
      type === 'java' ? 'Java Edition Server' : 'Bedrock Edition Server'
    document.getElementById('lookup-result-badge').textContent = 'Online'
    document.getElementById('lookup-result-badge').className = 'lookup-result-badge'

    // Icon
    const iconContainer = document.getElementById('lookup-icon-container')
    const iconLabel = document.getElementById('lookup-icon-label')

    if (data.icon) {
      iconContainer.innerHTML = `<img src="data:image/png;base64,${data.icon}" alt="Server Icon" onerror="this.parentElement.innerHTML='<span class=\\'icon-placeholder\\'><svg viewBox=\\'0 0 24 24\\'><rect x=\\'3\\' y=\\'3\\' width=\\'18\\' height=\\'18\\' rx=\\'2\\' ry=\\'2\\'/><circle cx=\\'8.5\\' cy=\\'8.5\\' r=\\'1.5\\'/><polyline points=\\'21 15 16 10 5 21\\'/></svg></span>'">`
      iconLabel.textContent = '64x64 pixels'
    } else {
      iconContainer.innerHTML = '<span class="icon-placeholder"><svg viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></span>'
      iconLabel.textContent = 'No icon available'
    }

    // MOTD
    const motdEl = document.getElementById('lookup-motd')
    const motdSection = document.getElementById('lookup-motd-section')
    if (data.motd) {
      motdSection.style.display = 'block'
      if (data.motd.html && data.motd.html.length > 0) {
        motdEl.innerHTML = data.motd.html.map(line => `<div>${line || '&nbsp;'}</div>`).join('')
      } else if (data.motd.clean && data.motd.clean.length > 0) {
        motdEl.innerHTML = data.motd.clean.map(line => `<div>${this.escapeHtml(line) || '&nbsp;'}</div>`).join('')
      } else if (data.motd.raw && data.motd.raw.length > 0) {
        motdEl.innerHTML = data.motd.raw.map(line => `<div>${this.escapeHtml(line) || '&nbsp;'}</div>`).join('')
      } else {
        motdEl.innerHTML = '<div style="color: var(--muted-foreground)">No MOTD available</div>'
      }
    } else {
      motdSection.style.display = 'none'
    }

    // Players
    const playersSection = document.getElementById('lookup-players-section')
    if (data.players) {
      playersSection.style.display = 'block'
      document.getElementById('lookup-players-count').textContent = `${data.players.online} / ${data.players.max}`
      document.getElementById('lookup-players-label').textContent = `${data.players.online} players online`

      const playersList = document.getElementById('lookup-players-list')
      playersList.innerHTML = ''
      if (data.players.list && data.players.list.length > 0) {
        const maxShow = 10
        data.players.list.slice(0, maxShow).forEach(player => {
          const badge = document.createElement('span')
          badge.className = 'lookup-player-badge'
          badge.textContent = player.name
          playersList.appendChild(badge)
        })
        if (data.players.list.length > maxShow) {
          const more = document.createElement('span')
          more.className = 'lookup-player-badge more'
          more.textContent = `+${data.players.list.length - maxShow} more`
          playersList.appendChild(more)
        }
      }
    } else {
      playersSection.style.display = 'none'
    }

    // Additional info
    document.getElementById('lookup-info-address').textContent =
      data.ip && data.port ? `${data.ip}:${data.port}` : 'Unavailable'
    document.getElementById('lookup-info-hostname').textContent =
      data.hostname || 'Unavailable'
    document.getElementById('lookup-info-version').textContent =
      (data.version && data.version.name) ? data.version.name : 'Unavailable'
    document.getElementById('lookup-info-software').textContent =
      data.software || 'Unavailable'

    // Show results
    this._resultsEl.style.display = 'block'

    // Scroll into view
    this._resultsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  escapeHtml (text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}
